<template>
  <div class="not-found">
    <div class="f-f">
      404
    </div>
    <div class="tip">
      :(  &nbsp;&nbsp; Sorry, the page you are visiting does not exist
    </div>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.not-found {
  width: 100vw;
  height: 100vh;
  background-color: #99cafe;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
    color: #fff;
  .f-f {
    font-size: 12.8rem;
    transform: rotate(30deg);
    margin-bottom: 4.8rem;
  }
  .tip {
    font-size: 3.6rem;
  }
}
</style>